import { UnidadMedidasArticulo } from "src/gql/schema"



export const unitOptions = [
    { label: "Kg (Kilogramos)", value: UnidadMedidasArticulo.Kg },
    { label: "g (gramo)", value: UnidadMedidasArticulo.G },
    { label: "mg (miligramo)", value: UnidadMedidasArticulo.Mg },
    { label: "L (litro)", value: UnidadMedidasArticulo.L },
    { label: "mL (mililitro)", value: UnidadMedidasArticulo.ML },
    { label: "Pz (Pieza)", value: UnidadMedidasArticulo.Pz },
    { label: "m (metro)", value: UnidadMedidasArticulo.M },
    { label: "mm (milimetro)", value: UnidadMedidasArticulo.Mm }
]

UnidadMedidasArticulo